import $script from 'scriptjs';
import reframe from 'reframe.js';

const api = 'https://player.vimeo.com/api/player.js';
let apiLoaded = false;

export default class VimeoPlayer {
  constructor(el) {
    const url = el.getAttribute('data-video-url');
    const urlParts = url.split('/');

    this.el = el;
    this.id = urlParts[urlParts.length - 1];

    this.onProgress = this._onProgress.bind(this);
    this.onProgressCallback = null;

    if (apiLoaded) {
      this._loadPlayer();
    } else {
      $script(api, () => {
        apiLoaded = true;

        this._loadPlayer();
      });
    }
  }

  play() {
    return new Promise(resolve => {
      this.onProgressCallback = resolve;
      this.player.on('progress', this.onProgress);
      this.player.play();
    });
  }

  unload() {
    // Reframe doesnt offer an unload method, so we'll manually remove the elements added
    if (this.frame) {
      const wrapper = this.frame.parentNode;
      const originalParent = wrapper.parentNode;

      originalParent.appendChild(this.frame);
      originalParent.removeChild(wrapper);
    }

    this.player
      .unload()
      .catch();
  }

  _loadPlayer() {
    this.player = new window.Vimeo.Player(this.el, { id: this.id });

    this.player
      .ready()
      .then(() => {
        this.frame = this.player.element;
        reframe(this.frame);
      });
  }

  _onProgress() {
    this.player.off('progress', this.onProgress);

    if (this.onProgressCallback) {
      this.onProgressCallback();
      this.onProgressCallback = null;
    }
  }
}
